/* ============================================================
   FORCE — motion layer
   Scroll reveal + count-up. Opt-in via [data-reveal] / [data-countup].
   Honors prefers-reduced-motion; degrades gracefully with no JS
   (initial hidden state is gated behind html.f-anim).
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = [].slice.call(document.querySelectorAll('[data-reveal]'));
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var d = parseFloat(el.getAttribute('data-reveal')) || 0;
        el.style.transitionDelay = (d * 80) + 'ms';
        el.classList.add('is-visible');
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Count-up ---------- */
  function groupThousands(n) {
    var s = String(n), out = '', c = 0, i;
    for (i = s.length - 1; i >= 0; i--) {
      out = s[i] + out; c++;
      if (c % 3 === 0 && i > 0) out = '.' + out;
    }
    return out;
  }

  function initCountup() {
    var els = [].slice.call(document.querySelectorAll('[data-countup]'));
    if (!els.length) return;

    function run(el) {
      var target = parseFloat(el.getAttribute('data-countup')) || 0;
      var prefix = el.getAttribute('data-countup-prefix') || '';
      var suffix = el.getAttribute('data-countup-suffix') || '';
      if (reduce) {
        el.textContent = prefix + groupThousands(target) + suffix;
        return;
      }
      var dur = 1500, start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + groupThousands(Math.round(target * eased)) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });

    els.forEach(function (el) { io.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCountup();
  });
})();
